import { icons, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import newExcel from "../../../assets/images/newExcel.svg";
export var Filters = [
    // {
    //   active: true,
    //   backgroundColor: "#E8EEFF",
    //   border: true,
    //   borderRadius: "8px",
    //   borderType: "1px solid #96ABFF",
    //   color: "#0D1BD9",
    //   sizes: "40px",
    //   type: "fullTextSearch",
    // },
    {
        label: "Limpiar Filtros",
        type: "cleanButton",
        variantButtons: variants.text,
        visible: true,
    },
    {
        disabled: false,
        label: "Exportar",
        listButtonDropdown: [
            {
                icons: icons.DownloadForOffline,
                id: "1",
                img: newExcel,
                name: "Descargar Excel",
            },
        ],
        showImage: true,
        type: "exportButton",
        variantButtons: variants.text,
        visible: true,
    },
    {
        id: "dateRange",
        label: "Rango de fechas",
        type: "dateRange",
    },
    // {
    //   allChecked: false,
    //   allCheckedTitle: "Todas las Sucursales",
    //   border: true,
    //   borderRadius: "8px",
    //   colorTitleFilter: "#0D0D0D",
    //   dropdownIndex: 1,
    //   id: "branch",
    //   label: "Sucursales",
    //   listDropDown: [
    //     {
    //       active: false,
    //       id: "4",
    //       name: "Sucursal central",
    //     },
    //     {
    //       active: false,
    //       id: "5",
    //       name: "Sucursal sur",
    //     },
    //     {
    //       active: false,
    //       id: "6",
    //       name: "Sucursal norte",
    //     },
    //     {
    //       active: false,
    //       id: "7",
    //       name: "Sucursal oriente",
    //     },
    //     {
    //       active: false,
    //       id: "8",
    //       name: "Sucursal occidente",
    //     },
    //   ],
    //   titleFilter: "",
    //   titleSearch: "buscar",
    //   type: "dropdownMultiple",
    // },
    // {
    //   allChecked: false,
    //   allCheckedTitle: "Todos los Productos",
    //   border: true,
    //   borderRadius: "8px",
    //   colorTitleFilter: "#0D0D0D",
    //   dropdownIndex: 2,
    //   id: "products",
    //   label: "Productos",
    //   listDropDown: [
    //     {
    //       active: false,
    //       id: "1",
    //       name: "Terminada",
    //     },
    //     {
    //       active: false,
    //       id: "2",
    //       name: "Cotizada",
    //     },
    //     {
    //       active: false,
    //       id: "3",
    //       name: "Eliminada",
    //     },
    //   ],
    //   titleFilter: "",
    //   titleSearch: "buscar",
    //   type: "dropdownMultiple",
    // },
];
